import { LocalAudioTrack } from "twilio-video";
import { useCallback, useState } from "react";
import useIsTrackEnabled from "./useIsTrackEnabled";
import useVideoContext from "./useVideoContext";

export default function useLocalAudioToggle() {
  const { room, localTracks, getLocalAudioTrack, onError } = useVideoContext();
  const localParticipant = room?.localParticipant;
  const audioTrack = localTracks.find(
    track => track.kind === "audio"
  ) as LocalAudioTrack;
  const isEnabled = useIsTrackEnabled(audioTrack);
  const [isPublishing, setIsPublishing] = useState(false);

  const toggleAudioEnabled = useCallback(() => {
    if (!isPublishing) {
      if (audioTrack) {
        audioTrack.isEnabled ? audioTrack.disable() : audioTrack.enable();
      } else {
        setIsPublishing(true);
        getLocalAudioTrack()
          .then((track: LocalAudioTrack) => {
            localParticipant?.publishTrack(track);
          })
          .catch(onError)
          .finally(() => setIsPublishing(false));
      }
    }
  }, [audioTrack, getLocalAudioTrack, isPublishing, localParticipant, onError]);

  return [isEnabled, toggleAudioEnabled] as const;
}
